import {
  Grid,
  Typography,
  Divider,
  Box,
  Chip,
  Paper,
  Button,
  TablePagination,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useIntl } from "react-intl";
import { useMemo, useState } from "react";
import { Spinner } from "react-bootstrap";
import ModalComponent from "components/Modal";
import EditIcon from "@mui/icons-material/Edit";
import { numericFormatter } from "react-number-format";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import env from "react-dotenv";

interface Empresa {
  id: number;
  clave: string;
  razon_social: string;
  nombre: string;
  rfc: string;
  direccion: string;
  contacto: string;
  correo: string;
  telefono: string;
  logo: File | null;
  id_usuario: number;
  estatus: number;
  created_at: Date;
  updated_at: Date;
}

interface DetalleCanjeProps {
  verEmpresa?: Empresa | null;
  procesandoEmpresa?: boolean;
  idUsuario?: number;
  setVerEditarEmpresa: React.Dispatch<React.SetStateAction<any>>;
  handleisAlertOpenCrearEmpresa: () => void;
}

const DetallesEmpresa = ({
  verEmpresa,
  procesandoEmpresa,
  idUsuario,
  setVerEditarEmpresa,
  handleisAlertOpenCrearEmpresa,
}: DetalleCanjeProps) => {
  if (!verEmpresa) return null;
  const intl = useIntl();

  const urlImagenReferencia = verEmpresa.logo
    ? `${env.API_URL_ASSETS}logo_empresas/${verEmpresa.logo}`
    : null;

  return (
    <Box sx={{ px: 0, pb: 0, mt: 0 }}>
      <Grid container spacing={2}>
        {/* Header */}
        <Grid item xs={12}>
          <Box sx={{ textAlign: "center", mb: 0 }}>
            <Typography variant="h4" color="primary" gutterBottom sx={{ color: "#004c93" }}>
              {verEmpresa.nombre}
            </Typography>
          </Box>
        </Grid>
        {/* Info general */}
        <Grid item xs={12}>
          <Paper elevation={2} sx={{ p: 2 }}>
            <Typography variant="h6" color="primary" gutterBottom sx={{ color: "#004c93" }}>
              Información principal
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Typography variant="body2" color="text.secondary">
                  Clave
                </Typography>
                <Typography variant="body2" fontWeight="medium">
                  {verEmpresa.clave}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="body2" color="text.secondary">
                  Nombre empresa
                </Typography>
                <Typography variant="body2" fontWeight="medium">
                  {verEmpresa.nombre}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="body2" color="text.secondary">
                  RFC
                </Typography>
                <Typography variant="body2" fontWeight="medium">
                  {verEmpresa.rfc}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="body2" color="text.secondary">
                  Razón social
                </Typography>
                <Typography variant="body2" fontWeight="medium">
                  {verEmpresa.razon_social}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="body2" color="text.secondary">
                  Logo de la empresa
                </Typography>
                {urlImagenReferencia ? (
                  <Box
                    component="img"
                    src={urlImagenReferencia}
                    alt="Imagen de referencia"
                    //onClick={handleOpenModalImagen}
                    sx={{
                      mt: 0.5,
                      width: "auto",
                      height: 30,
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <Typography variant="body2" fontWeight="medium">
                    Sin imagen de referencia
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="body2" color="text.secondary">
                  Fecha de registro
                </Typography>
                <Typography variant="body2" fontWeight="medium">
                  {new Date(verEmpresa.created_at).toLocaleDateString("es-MX")}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        {/* Info personal */}
        <Grid item xs={12}>
          <Paper elevation={2} sx={{ p: 2 }}>
            <Typography variant="h6" color="primary" gutterBottom sx={{ color: "#004c93" }}>
              Información de contacto
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Typography variant="body2" color="text.secondary">
                  Contacto
                </Typography>
                <Typography variant="body2" fontWeight="medium">
                  {verEmpresa.contacto}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="body2" color="text.secondary">
                  Correo
                </Typography>
                <Typography variant="body2" fontWeight="medium">
                  {verEmpresa.correo}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="body2" color="text.secondary">
                  Teléfono
                </Typography>
                <Typography variant="body2" fontWeight="medium">
                  {verEmpresa.telefono}
                </Typography>
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography variant="body2" color="text.secondary">
                  Dirección
                </Typography>
                <Typography variant="body2" fontWeight="medium">
                  {verEmpresa.direccion}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};
export default DetallesEmpresa;
